<template>
  <div class="d-flex h-40 align-center">
    <v-btn
      v-if="hasSpecialScenario"
      class="font-16 padding-x-0 font-medium"
      small
      text
      plain
      @click="openDialog"
    >
      {{ displayText }}
    </v-btn>
    <span v-else class="font-medium">{{ displayText }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { EventBus } from '@/utils/eventBus'
import { currencyFilter } from '@/utils/string'
import QuoteSummary from '@/models/dto/quoteSummary/QuoteSummary'
import { isExpiredV2 } from '@/utils/quote'

const props = defineProps<{
  row: QuoteSummary
}>()

const hasSpecialScenario = computed(() => {
  return props.row.promptCall || props.row.salesWillCall || props.row.promptBASCall
})

const displayText = computed(() => {
  const isPastExpiration = props.row.expirationDatetime && isExpiredV2(props.row.expirationDatetime)
  const isPickupInPast = props.row.pickupDatetime && new Date(props.row.pickupDatetime) < new Date()
  if (isPastExpiration || isPickupInPast) {
    return 'Expired'
  }

  if (hasSpecialScenario.value) {
    return 'More Info'
  }

  if (!props.row.price) {
    return 'View Prices'
  }

  return currencyFilter(props.row.price)
})

const openDialog = () => {
  const { promptCall, salesWillCall, promptBASCall } = props.row
  if (promptCall) {
    EventBus.$emit('open-prompt-call-dialog')
  } else if (salesWillCall) {
    EventBus.$emit('open-sales-will-call-dialog')
  } else if (promptBASCall) {
    EventBus.$emit('open-prompt-call-for-bas-dialog')
    return
  }
}
</script>

<style lang="scss" scoped>
::v-deep
  .v-btn--plain:not(.v-btn--active):not(.v-btn--loading):not(:focus):not(:hover)
  .v-btn__content {
  opacity: 1;
}
</style>
